import { TOOL_ENGINE_LABELS, SUPER_GROUP_ORDER, superGroupOf, superGroupLabel, sortToolEngines } from "./format";

// KNOWN 18개 도구+엔진 조합 전체 — 실사용 데이터 유무와 무관하게 "우리가 가진 도구/엔진 목록"
// 그대로 노출한다(요청 데이터에서 역산하지 않음). "도구별 사용량"·"전체 사용자" 두 탭의
// 필터가 공유하는 단일 소스(2026-07-17, 탭마다 다른 필터 컴포넌트 쓰던 걸 통일).
export const ALL_ENGINE_OPTIONS = sortToolEngines(
  Object.keys(TOOL_ENGINE_LABELS).map((key) => {
    const [tool, engine] = key.split("|");
    return { tool, engine, label: TOOL_ENGINE_LABELS[key] };
  })
);

// 필터 트리(슈퍼그룹 → 엔진) — 한 번만 계산.
export const FILTER_GROUPS = SUPER_GROUP_ORDER.map((sg) => ({
  superGroup: sg,
  label: superGroupLabel(sg),
  engines: ALL_ENGINE_OPTIONS.filter((e) => superGroupOf(e.tool) === sg),
}));

export const engineKey = (e) => `${e.tool}|${e.engine}`;
